import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import en from '@/i18n/vuetify/locale/en'
import fr from '@/i18n/vuetify/locale/fr'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { en, fr },
    current: 'en'
  },
  theme: {
    themes: {
      light: {
        primary: '#000000',
        secondary: '#003778',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  }
})
